var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m477 0h-442c-19.299 0-35 15.701-35 35v442c0 19.299 15.701 35 35 35h442c19.299 0 35-15.701 35-35 0-8.554 0-432.631 0-442 0-19.299-15.701-35-35-35zm-284.2 422.82v59.18h-66.4v-59.18zm30 0h66.4v59.18h-66.4zm96.4 0h66.4v59.18h-66.4zm-289.2-30v-273.64h452v273.64zm289.2-303.64v-59.18h66.4v59.18zm-30 0h-66.4v-59.18h66.4zm-96.4 0h-66.4v-59.18h66.4zm289.2-54.18v54.18h-66.4v-59.18h61.4c2.757 0 5 2.243 5 5zm-452 0c0-2.757 2.243-5 5-5h61.4v59.18h-66.4zm0 442v-54.18h66.4v59.18h-61.4c-2.757 0-5-2.243-5-5zm452 0c0 2.757-2.243 5-5 5h-61.4v-59.18h66.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m333.556 230.02-125.112-72.233c-19.998-11.548-45 2.868-45 25.98v144.467c0 23.089 24.979 37.539 45 25.98l125.112-72.233c20.005-11.55 20.013-40.407 0-51.961zm-140.112 98.209.004-144.459 125.108 72.23z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.e5cc6157.svg";
export { ForwardRef as ReactComponent };